import { TYPES } from './types'

export const toggleSidebar = () => ({
  type: TYPES.TOGGLE_SIDEBAR
})
